import React from 'react';
import BasicFroalaEditor from './basicFroala/BasicFroalaEditor';

function BasicDivFroala(props) {
    const {
        content,
        onUpdateContent,
        elementId,
        updateCampaignMessage,
        shouldRenderCloseButton,
        campaignMessageTemplateTypes,
        ...restProps
    } = props;

    const renderFroala = () => {
        switch (Number(content.template_type)) {
            case campaignMessageTemplateTypes.dialogTemplate1:
                return (
                    <BasicFroalaEditor
                        {...restProps}
                        content={content.imgMobileElements}
                        onUpdateContent={onUpdateContent}
                        isReadOnly={false}
                        type="image"
                        customStyle={getCustomDialogStyle(
                            campaignMessageTemplateTypes,
                            Number(content.template_type)
                        )}
                    />
                );
            case campaignMessageTemplateTypes.dialogTemplate2:
                return (
                    <>
                        <BasicFroalaEditor
                            {...restProps}
                            content={content.imgMobileElements}
                            onUpdateContent={onUpdateContent}
                            isReadOnly={false}
                            type="image"
                            customStyle={getCustomDialogStyle(
                                campaignMessageTemplateTypes,
                                Number(content.template_type)
                            )}
                        />
                        <BasicFroalaEditor
                            {...restProps}
                            content={content.textAreaElements}
                            onUpdateContent={onUpdateContent}
                            isReadOnly={false}
                            type="textarea"
                        />
                        <BasicFroalaEditor
                            {...restProps}
                            content={content.buttonElements}
                            onUpdateContent={onUpdateContent}
                            isReadOnly={false}
                            type="button"
                        />
                        {shouldRenderCloseButton && (
                            <BasicFroalaEditor
                                {...restProps}
                                content={content.closeButtonElements}
                                onUpdateContent={onUpdateContent}
                                isReadOnly={false}
                                type="button"
                                isCloseButton
                            />
                        )}
                    </>
                );
            case campaignMessageTemplateTypes.dialogTemplate3:
                return (
                    <>
                        <BasicFroalaEditor
                            {...restProps}
                            content={content.imgMobileElements}
                            onUpdateContent={onUpdateContent}
                            isReadOnly={false}
                            type="image"
                            customStyle={getCustomDialogStyle(
                                campaignMessageTemplateTypes,
                                Number(content.template_type)
                            )}
                        />
                        <BasicFroalaEditor
                            {...restProps}
                            content={content.buttonElements}
                            onUpdateContent={onUpdateContent}
                            isReadOnly={false}
                            type="button"
                        />
                        {shouldRenderCloseButton && (
                            <BasicFroalaEditor
                                {...restProps}
                                content={content.closeButtonElements}
                                onUpdateContent={onUpdateContent}
                                isReadOnly={false}
                                type="button"
                                isCloseButton
                                customButtonStyle='#000'
                            />
                        )}
                    </>
                );
            default:
                return (
                    <BasicFroalaEditor
                        {...restProps}
                        content={content.imgMobileElements}
                        onUpdateContent={onUpdateContent}
                        isReadOnly={false}
                        type="image"
                    />
                );
        }
    };
    return renderFroala();
}

export default BasicDivFroala;

export const getCustomDialogStyle = (campaignMessageTemplateTypes, type) => {
    switch (type) {
        case campaignMessageTemplateTypes.dialogTemplate1:
        case campaignMessageTemplateTypes.dialogTemplate2:
        case campaignMessageTemplateTypes.dialogTemplate3:
        default:
            return {
                maxWidth: '320px',
                width: '100%',
                textAlign: 'center'
            };
    }
};